<template>
  <div class="pr-date-picker">
    <el-date-picker
      v-model="dateValue"
      size="small"
      type="daterange"
      clearable
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOpt"
      @change="onDatePick"
    />
  </div>
</template>

<script>
export default {
  name: 'PR_DatePicker',
  data() {
    return {
      dateValue: [],
      pickerOpt: {
        disabledDate: function(date) {
          return Number(new Date(date)) > Number(new Date());
        },
        onPick: ({ maxDate, minDate }) => {
          if (!this.checkDateLimit([maxDate, minDate])) {
            this.$message.error('注意：所选日期不能超过三个月');
            this.$nextTick(() => {
              this.init();
            });
          }
        },
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [date, date]);
            },
          },
          {
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '本月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * (start.getDate() - 1),
              );
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '上个月',
            onClick(picker) {
              const d = new Date();
              d.setTime(d.getTime() - 3600 * 1000 * 24 * d.getDate());
              const [y, m] = [d.getFullYear(), d.getMonth() + 1];
              const days = getMonthDays(y, m);

              const start = new Date(`${y}/${m}/01`);
              const end = new Date(`${y}/${m}/${days}`);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    // init
    this.init();
  },
  methods: {
    // 检查限制
    checkDateLimit([maxDate = 0, minDate = 0]) {
      const oneDay = 24 * 60 * 60 * 1000;
      const toTime = (d) => Number(new Date(d));
      const offset = toTime(maxDate) - toTime(minDate);
      const days = Math.ceil(offset / oneDay) + 1;
      // <= 92d
      return days <= 92;
    },
    // 初始化
    init() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDate() - 1));
      this.dateValue = [start, end];
      this.onDatePick();
    },
    // 监听日期选择
    onDatePick() {
      const date = this.dateValue || [];

      if (date.length > 0 && this.checkDateLimit([...date].reverse())) {
        let [start, end] = date;
        let duration;
        start = setDate(Number(new Date(start)));
        end = setDate(Number(new Date(end)));
        duration = createDuration(start, end);

        this.$emit('pick', {
          start,
          end,
          duration,
        });
      }
    },
  },
};

// add zero
function addZero(num) {
  return (num > 9 ? '' : '0') + num;
}

// get total days
function getMonthDays(year, month) {
  return new Date(year, month, 0).getDate();
}

// format
function formatDate(date) {
  const [Y, M, D] = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
  // '-' => '/' 兼容 ios(暂时不做，统一用-)
  const dt = `${[Y, M, D].map(addZero).join('-')}`;
  return `${dt}`;
}

// setDate
function setDate(date = Number(new Date()), offset = 0) {
  const oneDay = 24 * 60 * 60 * 1000;
  let offsetDate = new Date(date + offset * oneDay);
  return formatDate(offsetDate);
}

// createDuration
function createDuration(start, end) {
  let [res, cur, _end] = [[], Number(new Date(start)), Number(new Date(end))];
  while (cur <= _end) {
    res.push(setDate(cur));
    cur = Number(new Date(setDate(cur, 1)));
  }
  return res;
}
</script>
